import React from 'react';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

function DatePicker({ adjustDateOnChange, allowSameDay, ariaDescribedBy, ariaInvalid, ariaLabelClose, ariaLabelledBy, ariaRequired, autoComplete, autoFocus, calendarClassName, calendarContainer, calendarIconClassname, calendarStartDay, children, chooseDayAriaLabelPrefix, className, clearButtonClassName, clearButtonTitle, closeOnScroll, customInput, customInputRef, customTimeInput, dateFormat, dateFormatCalendar, dayClassName, weekDayClassName, monthClassName, timeClassName, disabledDayAriaLabelPrefix, disabled, disabledKeyboardNavigation, dropdownMode, endDate, excludeDates, excludeDateIntervals, excludeTimes, filterDate, filterTime, fixedHeight, forceShowMonthNavigation, formatWeekDay, formatWeekNumber, highlightDates, holidays, icon, id, includeDates, includeDateIntervals, includeTimes, injectTimes, inline, focusSelectedMonth, isClearable, locale, maxDate, maxTime, minDate, minTime, monthsShown, name, nextMonthAriaLabel, nextMonthButtonLabel, nextYearAriaLabel, nextYearButtonLabel, onBlur, onCalendarClose, onCalendarOpen, onChange, onChangeRaw, onClickOutside, onDayMouseEnter, onFocus, onInputClick, onInputError, onKeyDown, onMonthChange, onMonthMouseLeave, onSelect, onWeekSelect, onYearChange, open, openToDate, peekNextMonth, placeholderText, popperClassName, popperContainer, popperModifiers, popperPlacement, popperProps, preventOpenOnFocus, previousMonthAriaLabel, previousMonthButtonLabel, previousYearAriaLabel, previousYearButtonLabel, readOnly, renderCustomHeader, renderDayContents, renderMonthContent, required, scrollableMonthYearDropdown, scrollableYearDropdown, selected, selectsEnd, selectsStart, selectsRange, shouldCloseOnSelect, showDisabledMonthNavigation, showFullMonthYearPicker, showMonthDropdown, showMonthYearDropdown, showMonthYearPicker, showPopperArrow, showPreviousMonths, showQuarterYearPicker, showTimeInput, showTimeSelect, showTimeSelectOnly, showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker, showWeekNumbers, showYearDropdown, showYearPicker, showIcon, startDate, startOpen, strictParsing, tabIndex, timeCaption, timeFormat, timeInputLabel, timeIntervals, title, todayButton, useShortMonthInDropdown, useWeekdaysShort, weekAriaLabelPrefix, monthAriaLabelPrefix, value, weekLabel, withPortal, portalId, portalHost, wrapperClassName, yearDropdownItemNumber, excludeScrollbar, enableTabLoop, yearItemNumber }) {

    return (
        <>
            <ReactDatePicker
                adjustDateOnChange={adjustDateOnChange}
                allowSameDay={allowSameDay}
                ariaDescribedBy={ariaDescribedBy}
                ariaInvalid={ariaInvalid}
                ariaLabelClose={ariaLabelClose}
                ariaLabelledBy={ariaLabelledBy}
                ariaRequired={ariaRequired}
                autoComplete={autoComplete}
                autoFocus={autoFocus}
                calendarClassName={calendarClassName}
                calendarContainer={calendarContainer}
                calendarIconClassname={calendarIconClassname}
                calendarStartDay={calendarStartDay}
                chooseDayAriaLabelPrefix={chooseDayAriaLabelPrefix}
                className={className}
                clearButtonClassName={clearButtonClassName}
                clearButtonTitle={clearButtonTitle}
                closeOnScroll={closeOnScroll}
                customInput={customInput}
                customInputRef={customInputRef}
                customTimeInput={customTimeInput}
                dateFormat={dateFormat}
                dateFormatCalendar={dateFormatCalendar}
                dayClassName={dayClassName}
                weekDayClassName={weekDayClassName}
                monthClassName={monthClassName}
                timeClassName={timeClassName}
                disabledDayAriaLabelPrefix={disabledDayAriaLabelPrefix}
                disabled={disabled}
                disabledKeyboardNavigation={disabledKeyboardNavigation}
                dropdownMode={dropdownMode}
                endDate={endDate}
                excludeDates={excludeDates}
                excludeDateIntervals={excludeDateIntervals}
                excludeTimes={excludeTimes}
                filterDate={filterDate}
                filterTime={filterTime}
                fixedHeight={fixedHeight}
                forceShowMonthNavigation={forceShowMonthNavigation}
                formatWeekDay={formatWeekDay}
                formatWeekNumber={formatWeekNumber}
                highlightDates={highlightDates}
                holidays={holidays}
                icon={icon}
                id={id}
                includeDates={includeDates}
                includeDateIntervals={includeDateIntervals}
                includeTimes={includeTimes}
                injectTimes={injectTimes}
                inline={inline}
                focusSelectedMonth={focusSelectedMonth}
                isClearable={isClearable}
                locale={locale}
                maxDate={maxDate}
                maxTime={maxTime}
                minDate={minDate}
                minTime={minTime}
                monthsShown={monthsShown}
                name={name}
                nextMonthAriaLabel={nextMonthAriaLabel}
                nextMonthButtonLabel={nextMonthButtonLabel}
                nextYearAriaLabel={nextYearAriaLabel}
                nextYearButtonLabel={nextYearButtonLabel}
                onBlur={onBlur}
                onCalendarClose={onCalendarClose}
                onCalendarOpen={onCalendarOpen}
                onChange={onChange}
                onChangeRaw={onChangeRaw}
                onClickOutside={onClickOutside}
                onDayMouseEnter={onDayMouseEnter}
                onFocus={onFocus}
                onInputClick={onInputClick}
                onInputError={onInputError}
                onKeyDown={onKeyDown}
                onMonthChange={onMonthChange}
                onMonthMouseLeave={onMonthMouseLeave}
                onSelect={onSelect}
                onWeekSelect={onWeekSelect}
                onYearChange={onYearChange}
                open={open}
                openToDate={openToDate}
                peekNextMonth={peekNextMonth}
                placeholderText={placeholderText}
                popperClassName={popperClassName}
                popperContainer={popperContainer}
                popperModifiers={popperModifiers}
                popperPlacement={popperPlacement}
                popperProps={popperProps}
                preventOpenOnFocus={preventOpenOnFocus}
                previousMonthAriaLabel={previousMonthAriaLabel}
                previousMonthButtonLabel={previousMonthButtonLabel}
                previousYearAriaLabel={previousYearAriaLabel}
                previousYearButtonLabel={previousYearButtonLabel}
                readOnly={readOnly}
                renderCustomHeader={renderCustomHeader}
                renderDayContents={renderDayContents}
                renderMonthContent={renderMonthContent}
                required={required}
                scrollableMonthYearDropdown={scrollableMonthYearDropdown}
                scrollableYearDropdown={scrollableYearDropdown}
                selected={selected}
                selectsEnd={selectsEnd}
                selectsStart={selectsStart}
                selectsRange={selectsRange}
                shouldCloseOnSelect={shouldCloseOnSelect}
                showDisabledMonthNavigation={showDisabledMonthNavigation}
                showFullMonthYearPicker={showFullMonthYearPicker}
                showMonthDropdown={showMonthDropdown}
                showMonthYearDropdown={showMonthYearDropdown}
                showMonthYearPicker={showMonthYearPicker}
                showPopperArrow={showPopperArrow}
                showPreviousMonths={showPreviousMonths}
                showQuarterYearPicker={showQuarterYearPicker}
                showTimeInput={showTimeInput}
                showTimeSelect={showTimeSelect}
                showTimeSelectOnly={showTimeSelectOnly}
                showTwoColumnMonthYearPicker={showTwoColumnMonthYearPicker}
                showFourColumnMonthYearPicker={showFourColumnMonthYearPicker}
                showWeekNumbers={showWeekNumbers}
                showYearDropdown={showYearDropdown}
                showYearPicker={showYearPicker}
                showIcon={showIcon}
                startDate={startDate}
                startOpen={startOpen}
                strictParsing={strictParsing}
                tabIndex={tabIndex}
                timeCaption={timeCaption}
                timeFormat={timeFormat}
                timeInputLabel={timeInputLabel}
                timeIntervals={timeIntervals}
                title={title}
                todayButton={todayButton}
                useShortMonthInDropdown={useShortMonthInDropdown}
                useWeekdaysShort={useWeekdaysShort}
                weekAriaLabelPrefix={weekAriaLabelPrefix}
                monthAriaLabelPrefix={monthAriaLabelPrefix}
                value={value}
                weekLabel={weekLabel}
                withPortal={withPortal}
                portalId={portalId}
                portalHost={portalHost}
                wrapperClassName={wrapperClassName}
                yearDropdownItemNumber={yearDropdownItemNumber}
                excludeScrollbar={excludeScrollbar}
                enableTabLoop={enableTabLoop}
                yearItemNumber={yearItemNumber} >
                {children}
            </ReactDatePicker>
        </>
    )
}

DatePicker.propTypes = {
    adjustDateOnChange: PropTypes.any,
    allowSameDay: PropTypes.any,
    ariaDescribedBy: PropTypes.any,
    ariaInvalid: PropTypes.any,
    ariaLabelClose: PropTypes.any,
    ariaLabelledBy: PropTypes.any,
    ariaRequired: PropTypes.any,
    autoComplete: PropTypes.any,
    autoFocus: PropTypes.any,
    calendarClassName: PropTypes.any,
    calendarContainer: PropTypes.any,
    calendarIconClassname: PropTypes.any,
    calendarStartDay: PropTypes.any,
    children: PropTypes.any,
    chooseDayAriaLabelPrefix: PropTypes.any,
    className: PropTypes.any,
    clearButtonClassName: PropTypes.any,
    clearButtonTitle: PropTypes.any,
    closeOnScroll: PropTypes.any,
    customInput: PropTypes.any,
    customInputRef: PropTypes.any,
    customTimeInput: PropTypes.any,
    dateFormat: PropTypes.any,
    dateFormatCalendar: PropTypes.any,
    dayClassName: PropTypes.any,
    weekDayClassName: PropTypes.any,
    monthClassName: PropTypes.any,
    timeClassName: PropTypes.any,
    disabledDayAriaLabelPrefix: PropTypes.any,
    disabled: PropTypes.any,
    disabledKeyboardNavigation: PropTypes.any,
    dropdownMode: PropTypes.any,
    endDate: PropTypes.any,
    excludeDates: PropTypes.any,
    excludeDateIntervals: PropTypes.any,
    excludeTimes: PropTypes.any,
    filterDate: PropTypes.any,
    filterTime: PropTypes.any,
    fixedHeight: PropTypes.any,
    forceShowMonthNavigation: PropTypes.any,
    formatWeekDay: PropTypes.any,
    formatWeekNumber: PropTypes.any,
    highlightDates: PropTypes.any,
    holidays: PropTypes.any,
    icon: PropTypes.any,
    id: PropTypes.any,
    includeDates: PropTypes.any,
    includeDateIntervals: PropTypes.any,
    includeTimes: PropTypes.any,
    injectTimes: PropTypes.any,
    inline: PropTypes.any,
    focusSelectedMonth: PropTypes.any,
    isClearable: PropTypes.any,
    locale: PropTypes.any,
    maxDate: PropTypes.any,
    maxTime: PropTypes.any,
    minDate: PropTypes.any,
    minTime: PropTypes.any,
    monthsShown: PropTypes.any,
    name: PropTypes.any,
    nextMonthAriaLabel: PropTypes.any,
    nextMonthButtonLabel: PropTypes.any,
    nextYearAriaLabel: PropTypes.any,
    nextYearButtonLabel: PropTypes.any,
    onBlur: PropTypes.any,
    onCalendarClose: PropTypes.any,
    onCalendarOpen: PropTypes.any,
    onChange: PropTypes.any,
    onChangeRaw: PropTypes.any,
    onClickOutside: PropTypes.any,
    onDayMouseEnter: PropTypes.any,
    onFocus: PropTypes.any,
    onInputClick: PropTypes.any,
    onInputError: PropTypes.any,
    onKeyDown: PropTypes.any,
    onMonthChange: PropTypes.any,
    onMonthMouseLeave: PropTypes.any,
    onSelect: PropTypes.any,
    onWeekSelect: PropTypes.any,
    onYearChange: PropTypes.any,
    open: PropTypes.any,
    openToDate: PropTypes.any,
    peekNextMonth: PropTypes.any,
    placeholderText: PropTypes.any,
    popperClassName: PropTypes.any,
    popperContainer: PropTypes.any,
    popperModifiers: PropTypes.any,
    popperPlacement: PropTypes.any,
    popperProps: PropTypes.any,
    preventOpenOnFocus: PropTypes.any,
    previousMonthAriaLabel: PropTypes.any,
    previousMonthButtonLabel: PropTypes.any,
    previousYearAriaLabel: PropTypes.any,
    previousYearButtonLabel: PropTypes.any,
    readOnly: PropTypes.any,
    renderCustomHeader: PropTypes.any,
    renderDayContents: PropTypes.any,
    renderMonthContent: PropTypes.any,
    required: PropTypes.any,
    scrollableMonthYearDropdown: PropTypes.any,
    scrollableYearDropdown: PropTypes.any,
    selected: PropTypes.any,
    selectsEnd: PropTypes.any,
    selectsStart: PropTypes.any,
    selectsRange: PropTypes.any,
    shouldCloseOnSelect: PropTypes.any,
    showDisabledMonthNavigation: PropTypes.any,
    showFullMonthYearPicker: PropTypes.any,
    showMonthDropdown: PropTypes.any,
    showMonthYearDropdown: PropTypes.any,
    showMonthYearPicker: PropTypes.any,
    showPopperArrow: PropTypes.any,
    showPreviousMonths: PropTypes.any,
    showQuarterYearPicker: PropTypes.any,
    showTimeInput: PropTypes.any,
    showTimeSelect: PropTypes.any,
    showTimeSelectOnly: PropTypes.any,
    showTwoColumnMonthYearPicker: PropTypes.any,
    showFourColumnMonthYearPicker: PropTypes.any,
    showWeekNumbers: PropTypes.any,
    showYearDropdown: PropTypes.any,
    showYearPicker: PropTypes.any,
    showIcon: PropTypes.any,
    startDate: PropTypes.any,
    startOpen: PropTypes.any,
    strictParsing: PropTypes.any,
    tabIndex: PropTypes.any,
    timeCaption: PropTypes.any,
    timeFormat: PropTypes.any,
    timeInputLabel: PropTypes.any,
    timeIntervals: PropTypes.any,
    title: PropTypes.any,
    todayButton: PropTypes.any,
    useShortMonthInDropdown: PropTypes.any,
    useWeekdaysShort: PropTypes.any,
    weekAriaLabelPrefix: PropTypes.any,
    monthAriaLabelPrefix: PropTypes.any,
    value: PropTypes.any,
    weekLabel: PropTypes.any,
    withPortal: PropTypes.any,
    portalId: PropTypes.any,
    portalHost: PropTypes.any,
    wrapperClassName: PropTypes.any,
    yearDropdownItemNumber: PropTypes.any,
    excludeScrollbar: PropTypes.any,
    enableTabLoop: PropTypes.any,
    yearItemNumber: PropTypes.any
}

DatePicker.defaultProps = {
    locale: {
        localize: {
            day: n => ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'][n],
            month: n => ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sept', 'Oct', 'Nov', 'Dic'][n]
        },
        formatLong: {
            date: () => 'dd/MM/yyyy'
        }
    }
}

export default DatePicker